import React, { useState, useEffect } from 'react';

const LazyImage = ({ src, alt, className, style, placeholderSrc }) => {
  const [imageSrc, setImageSrc] = useState(placeholderSrc || 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImageSrc(src);
      setImageLoaded(true);
    };
  }, [src]);

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={`${className} ${!imageLoaded ? 'lazy-loading' : ''}`}
      style={{
        ...style,
        transition: 'opacity 0.3s',
        opacity: imageLoaded ? 1 : 0.5,
      }}
      loading="lazy"
    />
  );
};

export default LazyImage; 